import graphql from "babel-plugin-relay/macro";
import { useMutation } from "react-relay";

import {
  ClaimCustomerRoundInBookingInput,
  useCustomerJoinNonPrePaidBookingMutation,
} from "./__generated__/useCustomerJoinNonPrePaidBookingMutation.graphql";

export const useCustomerJoinNonPrePaidBooking = () => {
  const [joinNonPrePaidBookingMutation, isJoiningNonPrePaidBooking] =
    useMutation<useCustomerJoinNonPrePaidBookingMutation>(
      useCustomerJoinNonPrePaidBookingMutationString
    );

  const handleCustomerJoinNonPrePaidBooking = (
    input: ClaimCustomerRoundInBookingInput,
    handleJoinSuccess: (slotOrBookingId: string) => void,
    handleJoinError: () => void
  ) => {
    joinNonPrePaidBookingMutation({
      variables: { input },
      onCompleted: (response, errors) => {
        if (
          response?.claimCustomerRoundInBooking?.success &&
          response?.claimCustomerRoundInBooking?.booking?.id
        ) {
          handleJoinSuccess(response.claimCustomerRoundInBooking.booking.id);
        } else {
          //Show error toast.
          handleJoinError();
        }
      },
      onError: (error) => {
        //Show error toast.
        handleJoinError();
      },
    });
  };

  return { handleCustomerJoinNonPrePaidBooking, isJoiningNonPrePaidBooking };
};

export const useCustomerJoinNonPrePaidBookingMutationString = graphql`
  mutation useCustomerJoinNonPrePaidBookingMutation(
    $input: ClaimCustomerRoundInBookingInput!
  ) {
    claimCustomerRoundInBooking(input: $input) {
      success
      errors {
        field
        code
        message
      }
      booking {
        id
      }
    }
  }
`;
